import { useCallback, useRef, useState } from 'react';
import type { SetStateAction } from 'react';

/** Reset during render so a new filter never issues a request for the previous page. */
export const useScopedPage = (scope: string) => {
  const [state, setState] = useState({ scope, page: 1 });
  const currentScope = useRef(scope);
  currentScope.current = scope;
  if (state.scope !== scope) setState({ scope, page: 1 });

  const setPage = useCallback((value: SetStateAction<number>) => {
    const scope = currentScope.current;
    setState(previous => {
      const previousPage = previous.scope === scope ? previous.page : 1;
      const page = typeof value === 'function' ? value(previousPage) : value;
      return previous.scope === scope && previous.page === page ? previous : { scope, page };
    });
  }, []);

  return [state.scope === scope ? state.page : 1, setPage] as const;
};
